import React, { Component } from "react";
import { withRouter, } from "react-router-dom";
import { Col, Container, Row } from 'reactstrap';
import Modal from 'react-modal'
import Select from 'react-select'
import TimeAgo from 'react-timeago'
import spanishStrings from 'react-timeago/lib/language-strings/es'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'
import moment from 'moment'

const formatter = buildFormatter(spanishStrings)
const customStylesOption = { control: styles => ({ ...styles, backgroundColor: '#fff', width: '90%', margin: '0 auto', marginBottom: 20, }), }
const customStyles = { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '70%',height: '70%',} };
class ModalsVentasPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      arrProd: {
        codigo: '',
        codigoSAT: '',
        nombre: '',
        type: '',
        categoria: '',
        costo: '',
        precio_compra: 0,
        precio_venta: 0,
        iva: 0,
      },

      arrNewAlmacenGral: {
        identificador: '',
        proveedor: '',
        kg_ticket: 0,
        kg_recibido_real: 0,
        total_pagado: 0,
      }
    }
  }
  componentDidMount() {

  }

  render() {
    const {
      isOpenAltaProductos,
      isOpenAltaAlmacenGral,

      //Modal buscar producto
      isOpenSearchProducto,
      isOpenSearchProductoByEntradaGral,
      isOpenNewProductoByProceso,
      isOpenViewProductoByProceso,
      isOpenEndProductoByProceso,
      arrayListResults,
      indexItemByKeyboard,
      valSearch,

      arrItemsProdByProc,

      arrProductoSelectedByEntradaGral,
      arrProcesosDisponiblesByProducto,

      //Modal inventarios
      modalsByInventarios,
      isOpenConfirmInfoProducto,

      isOpenHistoryEntradaAlmacen,
      arrHistoryEntradaAlmacen,
      
    } = this.props.subState
    const { arrProd, arrNewAlmacenGral, } = this.state

    if(modalsByInventarios) {
      let { arrStock, indexCategoria, indexProducto, cantidadFisica, } = this.props.subState
      if((indexCategoria > -2 && indexCategoria < 0) || indexProducto < 0)
        return null
      let arr = []
      if(indexCategoria === -2)
        arr = arrStock[indexProducto]
      else
        arr = arrStock[indexCategoria].list[indexProducto]
      
      let { nombre, clave, disponible, } = arr
      return (
        <>
          {
            /**
            * [INVENTARIOS]
            * CONFIRMAR PRODUCTO STATUS
            */
          }
          <Modal
            overlayClassName="Overlay__aplicaciones"
            isOpen={isOpenConfirmInfoProducto}
            onRequestClose={() => { this.subSetState({isOpenConfirmInfoProducto: false, indexCategoria: -1, indexProducto: -1, }) }}
            style={this.getStyleModal('isOpenConfirmInfoProducto')}
            contentLabel="Confirmar cantidades de producto"
            >
            <div className="modalBody__operador">
              <h4 style={{ marginBottom: 20, textAlign: 'center', }}>Confirmar existencia de: {nombre}</h4>
              <div style={{ margin: '0 auto', width: '80%', }}>
                <Row style={{ marginBottom: 20, }}>
                  <Col xs={5}>
                    <p style={{ marginTop: 10, }}>CANTIDAD EN SUCURSAL:</p>
                  </Col>
                  <Col>
                    <p className={'ws__inputCenter'}>{ disponible }</p>
                  </Col>
                </Row>
                <Row style={{ marginBottom: 20, }}>
                  <Col xs={5}>
                    <p style={{ marginTop: 10, }}>CANTIDAD FÍSICA:</p>
                  </Col>
                  <Col>
                    <input type={'text'} className={'ws__inputCenter'} value={cantidadFisica}
                      style={{ background: '#f3f3f3', }} placeholder={'Ingresa la cantidad en físico'}
                      onChange={(event) => { cantidadFisica = event.target.value; this.props.subSetState({ cantidadFisica, }); }}
                    />
                  </Col>
                </Row>
                <Row style={{ marginBottom: 20, }}>
                  <Col xs={5}>
                    <p style={{ marginTop: 10, }}>FALTANTE:</p>
                  </Col>
                  <Col>
                    <p className={'ws__inputCenter'}>{ this.number_format(parseFloat(disponible) - parseFloat(cantidadFisica), 2) }</p>
                  </Col>
                </Row>
                { parseFloat(cantidadFisica) != parseFloat(disponible) ? ( <p>SE NOTIFICARÁ AL SR GALDINO SOBRE ESTA CANTIDAD FALTANTE.</p> ) : null }
                <Row>
                  <Col>
                    <button className={'btn btn-primary'} onClick={() => { this.props.onMarkEnd() }} >MARCAR COMO VERIFICADO</button>
                  </Col>
                  <Col>
                    <button className={'btn btn-secondary'} onClick={() => { this.props.onMarkEnd(1) }} >REINICIAR EXISTENCIA</button>
                    <b>* Si realizas esta acción la cantidad de {cantidadFisica} será la nueva existencia.</b>
                  </Col>
                  <Col>
                    <button className={'btn btn-danger'} onClick={() => { this.subSetState({isOpenConfirmInfoProducto: false, indexCategoria: -1, indexProducto: -1, }) }} >Cerrar</button>
                  </Col>
                </Row>
              </div>
            </div>
          </Modal>
        </>
      )
    } else {
      if(typeof arrHistoryEntradaAlmacen === 'undefined')
        return null
      return (
        <>
          {
            /**
            * Historial entradas a almacen
            */
          }

          <Modal
            overlayClassName="Overlay__aplicaciones"
            isOpen={isOpenHistoryEntradaAlmacen}
            onRequestClose={() => { this.subSetState({isOpenHistoryEntradaAlmacen: false}) }}
            style={this.getStyleModal('isOpenHistoryEntradaAlmacen')}
            contentLabel="Entradas al almacen"
            >
            <div className="modalBody__operador">
                <h4 style={{ marginBottom: 20, textAlign: 'center', }}>Entradas al almacen</h4>
                {
                  arrHistoryEntradaAlmacen.index > -1 ? (
                    <div>
                      <p onClick={() => { arrHistoryEntradaAlmacen.index = -1; this.props.subSetState({arrHistoryEntradaAlmacen }) }} style={{ cursor: 'pointer', }}>Regresar</p>
                      {
                        arrHistoryEntradaAlmacen.productos.map((t,e) => (
                          <Row className={'ventasPage__listProductos'}>
                            <Col xs={8}><b>{t.nombre}</b></Col>
                            <Col xs={2}><p>{ t.cantidad }</p></Col>
                            <Col xs={2}><p>${ this.number_format(t.costo,2) }</p></Col>
                          </Row>
                        ))
                      }
                    </div>
                  ) : arrHistoryEntradaAlmacen.list.map((t,e) => (
                    <Row className={'ventasPage__listProductos'}>
                      <Col xs={6}><b>{t.referencia}</b></Col>
                      <Col xs={2}><p>{ moment(t.created_at).format('DD/MM/YYYY H:mm:ss') }</p></Col>
                      <Col>
                        <button
                          style={{ marginLeft: 5, marginBottom: 4, width: '100%', }}
                          className={'btn btn-secondary'}
                          onClick={ () => { arrHistoryEntradaAlmacen.index = e; this.props.subSetState({ arrHistoryEntradaAlmacen }); this.getProductosByEntradaAlmacen() }}
                        >Ver productos</button>
                      </Col>
                    </Row>
                  ))
                }
            </div>
          </Modal>

          {
            /**
            * ALTA DE PRODUCTOS
            */
          }

          <Modal
            overlayClassName="Overlay__aplicaciones"
            isOpen={isOpenAltaProductos}
            onRequestClose={() => { this.subSetState({isOpenAltaProductos: false}) }}
            style={this.getStyleModal('isOpenAltaProductos')}
            contentLabel="Registrar nuevo producto"
            >
            <div className="modalBody__operador">
                <h4 style={{ marginBottom: 20, textAlign: 'center', }}>Registrar un producto</h4>

                <div className={'modalsVentas__formAddProducto'}>
                  <p>Código</p>
                  <input type={'text'}
                    placeholder={'Ingresa un código'}
                    onChange={(event) => {
                      arrProd.codigo = event.target.value
                      this.setState({ arrProd, })
                    }}
                    value={arrProd.codigo}
                  />
                </div>

                <div className={'modalsVentas__formAddProducto'}>
                  <p>Código SAT</p>
                  <input type={'text'}
                    placeholder={'Ingresa un código de SAT'}
                    onChange={(event) => {
                      arrProd.codigoSAT = event.target.value
                      this.setState({ arrProd, })
                    }}
                    value={arrProd.codigoSAT}
                  />
                </div>

                <div className={'modalsVentas__formAddProducto'}>
                  <p>Nombre del producto</p>
                  <input type={'text'}
                    placeholder={'Ingresa la descripción del producto'}
                    onChange={(event) => {
                      arrProd.nombre = event.target.value
                      this.setState({ arrProd, })
                    }}
                    value={arrProd.nombre}
                  />
                </div>

                <div className={'modalsVentas__formAddProducto'}>
                  <p>Categoría del producto</p>
                  <Select
                    onChange={(item) => {
                      arrProd.type = item.type
                      arrProd.categoria = item.value
                      this.setState({ arrProd, })
                    }}
                    placeholder={'Haz click para buscar un producto'}
                    options={this.props.subState.arrayListCategorias}
                    styles={customStylesOption}
                  />
                </div>

                <div className={'modalsVentas__formAddProducto'}>
                  <p>¿Este producto tiene IVA?</p>
                  <p
                    style={{ cursor: 'pointer' }}
                    onClick={ () => {
                      arrProd.iva = !arrProd.iva
                      this.setState({ arrProd, })
                    }}
                  >{ arrProd.iva == 1 ? 'Si' : 'No' }</p>
                </div>

                <div className={'modalsVentas__formAddProducto'}>
                  <p>Precio de compra</p>
                  <input type={'text'}
                    placeholder={''}
                    onChange={(event) => {
                      arrProd.precio_compra = event.target.value
                      this.setState({ arrProd, })
                    }}
                    value={arrProd.precio_compra}
                  />
                </div>

                <div className={'modalsVentas__formAddProducto'}>
                  <p>Precio de venta</p>
                  <input type={'text'}
                    placeholder={''}
                    onChange={(event) => {
                      arrProd.precio_venta = event.target.value
                      this.setState({ arrProd, })
                    }}
                    value={arrProd.precio_venta}
                  />
                </div>

                <div style={{ textAlign: 'center', }}>
                  <button
                    className={'modalsVentas__btnAddProducto'}
                    onClick={() => { this.onAddProducto() }}
                  >Registrar producto</button>
                </div>

            </div>
          </Modal>

          {
            /**
            * ALTA DE ENTRADA ALMACEN GRAL
            */
          }
          <Modal
            overlayClassName="Overlay__aplicaciones"
            isOpen={isOpenAltaAlmacenGral}
            onRequestClose={() => { this.subSetState({isOpenAltaAlmacenGral: false}) }}
            style={this.getStyleModal('isOpenAltaAlmacenGral')}
            contentLabel="Registrar nuevo producto"
            >
            <div className="modalBody__operador">
                <h4 style={{ marginBottom: 20, textAlign: 'center', }}>Registrar nuevo combo</h4>

                <div className={'modalsVentas__formAddProducto'}>
                  <p>Identificador (opcional)</p>
                  <input type={'text'}
                    placeholder={'Ingresa un identificador'}
                    onChange={(event) => {
                      arrNewAlmacenGral.identificador = event.target.value
                      this.setState({ arrNewAlmacenGral, })
                    }}
                    value={arrNewAlmacenGral.identificador}
                  />
                </div>

                <div className={'modalsVentas__formAddProducto'}>
                  <p>Nombre del proveedor</p>
                  <input type={'text'}
                    placeholder={'Ingresa el nombre del proveedor'}
                    onChange={(event) => {
                      arrNewAlmacenGral.proveedor = event.target.value
                      this.setState({ arrNewAlmacenGral, })
                    }}
                    value={arrNewAlmacenGral.proveedor}
                  />
                </div>

                <div className={'modalsVentas__formAddProducto'}>
                  <p>Cantidad (KG) ticket</p>
                  <input type={'number'}
                    placeholder={''}
                    onChange={(event) => {
                      arrNewAlmacenGral.kg_ticket = event.target.value
                      this.setState({ arrNewAlmacenGral, })
                    }}
                    value={arrNewAlmacenGral.kg_ticket}
                  />
                </div>

                <div className={'modalsVentas__formAddProducto'}>
                  <p>Cantidad (KG) recibida real</p>
                  <input type={'number'}
                    placeholder={''}
                    onChange={(event) => {
                      arrNewAlmacenGral.kg_recibido_real = event.target.value
                      this.setState({ arrNewAlmacenGral, })
                    }}
                    value={arrNewAlmacenGral.kg_recibido_real}
                  />
                </div>

                <div className={'modalsVentas__formAddProducto'}>
                  <p>Total pagado</p>
                  <input type={'number'}
                    placeholder={''}
                    onChange={(event) => {
                      arrNewAlmacenGral.total_pagado = event.target.value
                      this.setState({ arrNewAlmacenGral, })
                    }}
                    value={arrNewAlmacenGral.total_pagado}
                  />
                </div>

                <div style={{ textAlign: 'center', }}>
                  <button
                    className={'btn btn-primary modalsVentas__btnAddProducto'}
                    onClick={() => { this.onAddEntradaAlmacenGral() }}
                  >Registrar combo</button>
                </div>

            </div>
          </Modal>


          <Modal
            overlayClassName="Overlay__aplicaciones"
            isOpen={isOpenNewProductoByProceso}
            onRequestClose={() => { this.subSetState({isOpenNewProductoByProceso: false}) }}
            style={customStyles}
            contentLabel="Registrar productos por proceso"
            >
            
            <Row style={{ width: '99%', margin: '0 auto' }}>
              <Col className={'z-depth-1'}>
                
                <Row>
                  <p className="regVentaPage__product" style={{ padding: '0 15px', fontWeight: '400', marginBottom: 10, color: '#444', textAlign: 'center', width: '100%', }}>Productos procesados</p>
                  <hr />
                </Row>

                <Row>
                  <Col xs={'3'}>
                    <b>Código</b>
                  </Col>
                  <Col xs={'5'}>
                    <b>Nombre</b>
                  </Col>
                  <Col xs={'3'}>
                    <b>Cantidad en KG</b>
                  </Col>
                  <Col xs={'1'}>
                    <b>Opciones</b>
                  </Col>
                </Row>

                <hr />

                { this.makeItemsProductosByProceso() }

              </Col>

            </Row>

          </Modal>

          <Modal
            overlayClassName="Overlay__aplicaciones"
            isOpen={isOpenViewProductoByProceso}
            onRequestClose={() => { this.subSetState({isOpenViewProductoByProceso: false}) }}
            onAfterOpen={() => { this.getViewProductoByProceso(this.props.subState.optViewProdByProc) }} // get info
            style={customStyles}
            contentLabel="Ver productos en proceso"
            >
            
            <Row style={{ width: '99%', margin: '0 auto' }}>
              <Col>
                
                <Row>
                  <p className="regVentaPage__product" style={{ padding: '0 15px', fontWeight: '500', marginBottom: 10, color: '#444', textAlign: 'center', width: '100%', }}>Productos registrados del proceso</p>
                </Row>

                <hr />

                <Row>
                  {/* Ver por */}
                  <Col xs={12}>
                    <Select
                      placeholder="VER HISTORICO"
                      // defaultInputValue="Dirección"
                      options={[
                        {opt: 1, nombre: 'VER HISTORICO', label: 'VER HISTORICO', value: 'VER HISTORICO', },
                        {opt: 2, nombre: 'VER ACUMULADO', label: 'VER ACUMULADO', value: 'VER ACUMULADO', },
                      ]}
                      onChange={(val) => {this.handleChangeViewProductoByProceso(val)}}
                      styles={customStylesOption}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col><b>Clave</b></Col>
                  <Col><b>Nombre del producto</b></Col>
                  <Col><b>KG registrados</b></Col>
                  <Col><b>Fecha de registro</b></Col>
                </Row>
                {
                  arrItemsProdByProc.map((t,e) => (
                    <Row style={{ marginTop: 20, marginBottom: 20, }} className={'ws__list_identificador'} onClick={() => {  }}>
                      <Col><p>{ t.clave }</p></Col>
                      <Col><p>{ t.nombre }</p></Col>
                      <Col><p>{ this.number_format( t.cantidad , 2)} KG</p></Col>
                      <Col><p>{ moment(t.created_at).format('YYYY-MM-DD') }</p></Col>
                    </Row>
                  ))
                }

                <button className={'btn btn-danger'} onClick={() => { this.subSetState({isOpenViewProductoByProceso: false}) }} >Cerrar</button>

              </Col>

            </Row>

          </Modal>

          <Modal
            overlayClassName="Overlay__aplicaciones"
            isOpen={isOpenEndProductoByProceso}
            onRequestClose={() => { this.subSetState({isOpenEndProductoByProceso: false}) }}
            style={customStyles}
            contentLabel="Finalizar registros en este proceso"
            >
            
            <Row style={{ width: '99%', margin: '0 auto' }}>
              <Col>
                
                <Row>
                  <p className="regVentaPage__product" style={{ padding: '0 15px', fontWeight: '500', marginBottom: 10, color: '#444', textAlign: 'left', width: '100%', }}>Recomendación</p>
                  <p className="regVentaPage__product" style={{ padding: '0 15px', fontWeight: '400', marginBottom: 10, color: '#444', textAlign: 'left', width: '100%', }}>
                    Verifica que todos los productos hayan sido registrados en este proceso primario. Los KG restantes se tomarán como merma de este proceso.
                  </p>
                  <p className="regVentaPage__product" style={{ padding: '0 15px', fontWeight: '400', marginBottom: 10, color: '#444', textAlign: 'left', width: '100%', }}>KG sobrantes: {this.returnKGSobrantes()}</p>
                  <hr />
                </Row>

                <hr />

                <button className={'btn btn-primary'} onClick={() => { this.onEndProductoByProceso() }}>Concluir proceso</button>

              </Col>

            </Row>

          </Modal>

          <Modal
            overlayClassName="Overlay__aplicaciones"
            isOpen={isOpenSearchProducto}
            onRequestClose={() => { this.subSetState({isOpenSearchProducto: false}) }}
            style={customStyles}
            contentLabel="Seleccionar un producto"
            >
            <div className="modalBody__operador">
              <Row className="modalBody__corte"> 
                <Col>
                  <h4 style={{ margin: 0, }}>Seleccionar un producto</h4>
                  <input
                    type="text"
                    placeholder="Ingresa el nombre del producto..."
                    value={valSearch}
                    onChange={(e) => this.onViewProduct(e.target.value) }
                    style={{ margin: '20px auto', }}
                  />

                  <Row>
                    <Col xs={'8'}>
                      <b>Nombre</b>
                    </Col>
                    <Col xs={'4'}>
                      <b>Categoría</b>
                    </Col>
                  </Row>
                  {
                    arrayListResults.map((t,e) => (
                      <div key={`ws_list_compra_${e}`}>
                        <Row
                          onClick={ () => { this.props.selectItemProduct(e) } }
                          style={{ width: '100%', margin: '0 auto', marginTop: 5, }}
                          className={`regVentaPage__content ${e === indexItemByKeyboard ? 'regVentaPage__content__active' : null}`}
                        >
                          <div className="regVentaPage__separator"></div>
                          <Col xs={'8'} className="regVentaPage__listProduct">
                            <p style={{ color: '#333', margin: 0, }}>{t.nombre}</p>
                          </Col>
                          <Col xs={'4'} className="regVentaPage__listPrices">
                            <p style={{ color: '#333', margin: 0, }}>{t.categoria}</p>
                          </Col>
                        </Row>
                      </div>
                    ))
                  }

                </Col>
              </Row>
            </div>
          </Modal>

          <Modal
            overlayClassName="Overlay__aplicaciones"
            isOpen={isOpenSearchProductoByEntradaGral}
            onRequestClose={() => { this.subSetState({isOpenSearchProductoByEntradaGral: false}) }}
            style={customStyles}
            contentLabel="Seleccionar el producto a traspasar"
            >
            <div className="modalBody__operador">
              <Row className="modalBody__corte"> 
                <Col>
                  {
                    !arrProductoSelectedByEntradaGral.id_producto
                    ? <h4 style={{ margin: 0, }}>Seleccionar el producto a traspasar</h4>
                    : <h4 style={{ margin: 0, }}>{arrProductoSelectedByEntradaGral.nombre}</h4>
                  }

                  <input
                    type="text"
                    placeholder="Ingresa el nombre del producto..."
                    value={valSearch}
                    onChange={(e) => this.onViewProduct(e.target.value) }
                    style={{ margin: '20px auto', }}
                  />

                  {
                    arrayListResults.length > 0 ? (
                      <>
                        <Row>
                          <Col xs={'8'}>
                            <b>Nombre</b>
                          </Col>
                          <Col xs={'4'}>
                            <b>Categoría</b>
                          </Col>
                        </Row>
                        {
                        arrayListResults.map((t,e) => (
                          <div key={`ws_list_compra_${e}`}>
                            <Row
                              onClick={ () => { this.props.selectItemProductFromProcesos(e) } }
                              style={{ width: '100%', margin: '0 auto', marginTop: 5, }}
                              className={`regVentaPage__content ${e === indexItemByKeyboard ? 'regVentaPage__content__active' : ''}`}
                            >
                              <div className="regVentaPage__separator"></div>
                              <Col xs={'8'} className="regVentaPage__listProduct">
                                <p style={{ color: '#333', margin: 0, }}>{t.nombre}</p>
                              </Col>
                              <Col xs={'4'} className="regVentaPage__listPrices">
                                <p style={{ color: '#333', margin: 0, }}>{t.categoria}</p>
                              </Col>
                            </Row>
                          </div>
                        ))
                        }
                      </>
                    ) : null
                  }

                  {
                    arrProcesosDisponiblesByProducto.length > 0 ? (
                      <>
                        <Row>
                          <Col xs={'4'}>
                            <b>Nombre</b>
                          </Col>
                          <Col xs={'3'} style={{textAlign: 'center'}}>
                            <b>KG disponibles</b>
                          </Col>
                          <Col xs={'3'} style={{textAlign: 'center'}}>
                            <b>KG a traspasar</b>
                          </Col>
                          <Col xs={'2'} style={{ textAlign: 'center'}}>
                            <b style={{ display: 'block', width: '100%', }}>KG restantes</b>
                          </Col>
                        </Row>
                        {
                          arrProcesosDisponiblesByProducto.map((t,e) => (
                            <Row
                              onClick={ () => {
                              }}
                              key={`ws_list_proceso_${e}`}
                              style={{ width: '100%', margin: '0 auto', marginTop: 10, marginBottom: 10, }}
                              className="regVentaPage__content"
                            >
                              <div className="regVentaPage__separator"></div>
                              <Col xs={'4'} className="regVentaPage__listProduct">
                                <p style={{ color: '#333' }}>{t.value}</p>
                              </Col>
                              <Col xs={'3'} className="regVentaPage__listProduct">
                                <p style={{ color: '#333', textAlign: 'center' }}>{ this.number_format(t.kg_disponibles,2) }</p>
                              </Col>
                              <Col xs={'3'} className="regVentaPage__listProduct">
                                <input
                                  value={t.kg_traspaso}
                                  onChange={ (eInput) => { this.onUpdateProdTraspaso(t, e, eInput.target.value) } }
                                  type={"number"}
                                  placeholder={"Ingresa los KG..."}
                                  style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
                                />
                              </Col>
                              <Col xs={'2'} className="regVentaPage__listProduct">
                                <p style={{ color: '#333', textAlign: 'center', }}>{
                                  (t.kg_disponibles - t.kg_traspaso) >= 0 ?
                                    this.number_format(t.kg_disponibles - t.kg_traspaso,2)
                                  : 'Error'
                                }</p>
                              </Col>
                            </Row>
                          ))
                        }
                      </>
                    ) : null
                  }

                  <Row>
                    { this.makeButtonAddProductoByProceso() }
                  </Row>
                </Col>
              </Row>
            </div>
          </Modal>
        </>
      )
    }

  }

  getProductosByEntradaAlmacen() {
    let { arrHistoryEntradaAlmacen } = this.props.subState
    let { index, list, } = arrHistoryEntradaAlmacen

    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getProductosByEntradaAlmacen", this.headersPOST({ id_entrada: list[ index ].id_entrada, }))
    .then(response => response.json())
    .then((response) => {
      arrHistoryEntradaAlmacen.productos = response.list
      this.props.subSetState({ arrHistoryEntradaAlmacen, })
    }).catch((error) => console.info(error));
  }

  makeButtonAddProductoByProceso() {
    let { arrProcesosDisponiblesByProducto } = this.props.subState
    let flagTraspaso = false
    arrProcesosDisponiblesByProducto.map((t) => { if(t.kg_traspaso > 0) { flagTraspaso = true; } })
    if(flagTraspaso) {
      return (
        <button style={{ cursor: 'pointer', margin: '0 auto', }} className={'btn btn-secondary'}
        onClick={ () => { this.setAddProductoWProceso() }}>Agregar producto</button>
      )
    }
    return null
  }

  setAddProductoWProceso() {
    let { arrProductoSelectedByEntradaGral, arrProcesosDisponiblesByProducto, arrProductosByTraspaso, } = this.props.subState

    //Agregamos el item en el array de registros
    let cantidad = 0, arr = []

    arrProcesosDisponiblesByProducto.map((t) => {
      if(t.kg_traspaso > 0) {
        //Se agrega
        cantidad += parseFloat(t.kg_traspaso);
        arr.push( t )
      }
    })

    let newItem = [{
      ...arrProductoSelectedByEntradaGral,
      cantidad,
      costo_compra: 0,
      costo_venta: 0,
      arrIDProcesos: arr,
    }]

    arrProductosByTraspaso = [ ...arrProductosByTraspaso, ...newItem ]
    this.props.subSetState({ arrProductosByTraspaso, arrProductoSelectedByEntradaGral: {}, arrProcesosDisponiblesByProducto: [], isOpenSearchProductoByEntradaGral: false, })    
  }

  onUpdateProdTraspaso(t, e, value) {
    let { arrProcesosDisponiblesByProducto } = this.props.subState
    arrProcesosDisponiblesByProducto[e].kg_traspaso = value
    this.props.subSetState({ arrProcesosDisponiblesByProducto })
  }

  /* VER PROCESOS */

  handleChangeViewProductoByProceso(val) {
    this.props.subSetState({ optViewProdByProc: val.opt });
    this.getViewProductoByProceso(val.opt)
  }

  getViewProductoByProceso(opt) {
    const { arrProcesos, indexItemByProceso, optViewProdByProc, } = this.props.subState
    const data = {
      id_proceso: arrProcesos[indexItemByProceso].id_proceso,
      opt,
    }
    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerPreproduction.php?opt=getViewProductoByProceso", this.headersPOST({...data}))
    .then(response => response.json())
    .then((response) => {
      this.props.subSetState({
        arrItemsProdByProc: response,
      })
    }).catch((error) => console.info(error));

  }

  /* // VER PROCESOS */


  returnKGSobrantes() {
    const { arrProcesos, indexItemByProceso, } = this.props.subState
    if(indexItemByProceso === -1)
      return 'no se pudo obtener este dato'

    return this.number_format(( arrProcesos[indexItemByProceso].kg_sin_procesar ), 2)

  }

  makeItemsProductosByProceso() {
    const { arrItemsAlmacen, arrayListProductos, arrProcesos, indexItemByProceso, } = this.props.subState

    if(indexItemByProceso === -1)
      return null

    let cantidadDisponible = arrProcesos[indexItemByProceso].kg_sin_procesar,
    cantidadARegistrar = 0
    arrItemsAlmacen.map((t) => {
      cantidadARegistrar += parseFloat(t.cantidad)
    })

    let isAvailable = ( cantidadDisponible >= cantidadARegistrar ) ? true : false

    //Show item new
    return (

      <>
        {
          arrItemsAlmacen.map((t,e) => (
            <Row>
              <Col xs={'3'}>
                <b>{t.codigo}</b>
              </Col>
              <Col xs={'5'}>
                <b>{t.producto}</b>
              </Col>
              <Col xs={'3'}>
                <input
                  ref={input => {
                    this[`inputAlmacenNew${e}`] = input;
                  }}
                  type={'number'}
                  onChange={ (event) => {
                    arrItemsAlmacen[e].cantidad = event.target.value;
                    this.props.subSetState({ arrItemsAlmacen });
                  }}
                  value={ t.cantidad }
                  placeholder={'Ingresa la cantidad'}
                  style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
                />
              </Col>
              <Col xs={'1'}>
                <p
                  style={{ cursor: 'pointer', color: 'red', fontWeight: '800', }}
                  onClick={() => {
                    const arr = arrItemsAlmacen.filter(function(item, index) { return index !== e })
                    this.props.subSetState({ arrItemsAlmacen: arr })
                  }}
                >X</p>
              </Col>
            </Row>
          ))
        }

        <hr />

        {
          arrayListProductos.length > 0 ? (
            <Row style={{ marginTop: 20, }}>
              <Col xs={'12'} style={{ cursor: 'pointer', }}
                onClick={ () => { this.setBindProductos() }}
                >
                <p className={'ws__listproduct_titleselect'}>Elige un producto para agregar a la lista</p>
              </Col>
              {
                /*
                Buscador no funciona por que la variable no está definida en ventas.page.jsx
                <Col xs={'6'}>
                  <input
                    type="text"
                    id={'ws-input-search-code'}
                    autoComplete="off"
                    placeholder="Ingresa el código del producto..."
                    value={this.state.valSearchByFullCode}
                    onChange={(e) => { this.setState({ valSearchByFullCode: e.target.value }) } }
                    onKeyDown={this._handleKeyDown}
                    ref={(input) => { this.inputSearchByCode = input;  }}
                    style={{ margin: '20px auto', marginTop: 0, width: '100%', background: '#f3f3f3', border: '1px solid #ccc', borderRadius: 4, }}
                  />
                </Col>
                */
              }
            </Row>
          ) : null
        }

        {
          arrItemsAlmacen.length > 0
          ? (
              <>
              {
                isAvailable ? (
                  <>
                    <p style={{ textAlign: 'right', color: 'green' }}>KG Disponibles: {this.number_format( (cantidadDisponible - cantidadARegistrar) , 2)}</p>
                    <p
                      className={'modalsVentas__btnAddProducto'}
                      onClick={() => { this.onRegisterProductosByProceso() }}
                    >Registrar entrada</p>
                  </>
                ) : (
                  <p style={{ textAlign: 'right', color: 'red' }}>No es posible registrar más KG.</p>
                )
              }
              </>
          ) : null
        }

      </>
    )
  }

  setBindProductos() {
    this.props.subSetState({ isOpenSearchProducto: true })
  }

  onRegisterProductosByProceso() {
    const { id_vendedor, id_sucursal, } = this.props.initState
    const { arrItemsAlmacen, fecha_entrada_almacen, serie_almacen, referencia_almacen, arrAlmacenGral, indexItemByCombo, arrProcesos, indexItemByProceso, } = this.props.subState

    //Validamos que todos los items ya tengan cantidad y costo
    let flag = true
    for(var a in arrItemsAlmacen) {
      if( arrItemsAlmacen[a].cantidad == '' ) {
        flag = false;
      }

      if( a == (arrItemsAlmacen.length - 1) ) {
        
        //Registramos los productos que salieron en el proceso en la BD
        if(!flag) {
          alert('Por favor, registra la cantidad de cada producto.')
          return false;
        } else {
          const data = {
            id_vendedor,
            id_sucursal,
            id_combo: arrAlmacenGral[indexItemByCombo].id_combo,
            id_proceso: arrProcesos[indexItemByProceso].id_proceso,
            arrItemsAlmacen,
          }

          if (window.confirm(`¿Estás seguro que deseas registrar esta entrada?`)) {

            fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setRegisterProductoByProceso", this.headersPOST({...data}))
            .then(response => response.json())
            .then((response) => {
              this.props.subSetState({
                arrItemsAlmacen: [],
                isOpenNewProductoByProceso: false,
                arrProcesos: response,
              })
              alert('Productos registrados con éxito.')
            }).catch((error) => console.info(error));
          }

        }
      }
    }
    return false
  }

  onEndProductoByProceso() {
    const { arrAlmacenGral, indexItemByCombo, arrProcesos, indexItemByProceso, } = this.props.subState
    const data = {...arrProcesos[indexItemByProceso], id_combo: arrAlmacenGral[indexItemByCombo].id_combo, }

    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setEndProductoByProceso", this.headersPOST({...data}))
    .then(response => response.json())
    .then((response) => {
      this.props.subSetState({
        isOpenEndProductoByProceso: false,
        arrProcesos: response,
      })
      alert('Proceso marcado como finalizado.')

      fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getCombosAlmacenGral", this.headersPOST({  }))
      .then(response => response.json())
      .then((response) => {
        this.props.subSetState({ arrAlmacenGral: response.combos, arrTraspasosPendientes: response.pendientes, arrConfirmadosPendientes: response.confirmados, })
      })

    }).catch((error) => console.info(error));
  }


  /*************
  **
  ** MODAL ALTA
  **
  ************/


  onAddProducto() {
    const { arrProd } = this.state
    const { codigo, nombre, type, categoria, precio_venta, } = arrProd
    //Validar
    if( codigo.trim() == '' || nombre.trim() == '' || type == '' ) {
      alert('Por favor, rellena los campos del formulario.');
      return false
    }


    //Registrar en BD
    const data = {
      ...arrProd,
      id_sucursal: this.props.initState.id_sucursal,
      id_vendedor: this.props.initState.id_vendedor,
    }

    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setRegisterProducto", this.headersPOST({...data}))
    .then(response => response.json())
    .then((response) => {

      if(response.status === 'duplicated') {
        //Aguas
        alert(`ERROR, el código o producto ya existe bajo el nombre: ${response.nombre}`)
        return false
      }

      //Finalizado agregamos en el array de productos
      const { arrayListProductos, arrayMinListProductos, } = this.props.subState

      arrayListProductos.push({
        categoria,
        fecha_cambio_costo: response.fecha,
        folio: codigo,
        id_producto: response.id_producto,
        nombre: (codigo + " - " + nombre),
        precio_venta,
        update: 0,
      })

      arrayMinListProductos.push({
        id_producto: response.id_producto,
        label: (codigo + " - " + nombre),
        value: (codigo + " - " + nombre),
      })

      this.props.subSetState({ arrayListProductos, arrayMinListProductos, isOpenAltaProductos: false, })

      this.setState({
        arrProd: {
          codigo: '',
          codigoSAT: '',
          nombre: '',
          type: '',
          categoria: '',
          costo: '',
          precio_compra: 0,
          precio_venta: 0,
          iva: 0,
        }
      })

      alert("Producto registrado con éxito.")
    })
  }


  /*************
  **
  ** MODAL ENTRADA GRAL ALMACEN
  **
  ************/


  onAddEntradaAlmacenGral() {
    const { arrNewAlmacenGral } = this.state
    const { identificador, proveedor, kg_ticket, kg_recibido_real, total_pagado, } = arrNewAlmacenGral

    //Validar
    if(
      proveedor.trim() == '' ||
      kg_ticket.trim() == '' ||
      kg_recibido_real.trim() == '' ||
      total_pagado.trim() == '') {
      alert('Por favor, rellena los campos del formulario.');
      return false
    }


    //Registrar en BD
    // console.
    const data = {
      ...arrNewAlmacenGral,
      id_sucursal: this.props.initState.id_sucursal,
      id_usuario: this.props.initState.id_usuario,
    }


    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setRegisterAlmacenGral", this.headersPOST({...data}))
    .then(response => response.json())
    .then((response) => {

      this.setState({
        arrNewAlmacenGral: {
          identificador: '',
          proveedor: '',
          kg_ticket: 0,
          kg_recibido_real: 0,
          total_pagado: 0,
        }
      })

      this.subSetState({isOpenAltaAlmacenGral: false})

      //Recargando toda la info de combos
      fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getCombosAlmacenGral", this.headersPOST({  }))
      .then(response => response.json())
      .then((response) => {
        this.props.subSetState({ arrAlmacenGral: response.combos, arrTraspasosPendientes: response.pendientes, arrMermasPendientes: response.merma, })
      })


      alert("Entrada a almacen registrada con éxito.")
    })
  }

  /*************
  **
  ** MODAL BUSCAR PRODUCTO
  **
  ************/

  onViewProduct(val) {
    let { arrayListProductos } = this.props.subState

    this.props.subSetState({ valSearch: val })
    let countLimit = 0

    arrayListProductos = arrayListProductos.filter(function(producto, index) {
      if(countLimit <= 10) {
        if(typeof producto.nombre === 'undefined' || !producto.nombre) {
        } else {
          if(producto.nombre.toLowerCase().indexOf(val.toLowerCase()) !== -1) {
            countLimit++
            return true
          }
        }
      }
    });
    this.props.subSetState({ arrayListResults: arrayListProductos });
  }

  initsetState(param) {
    this.props.initsetState(param)
    return true
  }

  subSetState(param) {
    this.props.subSetState(param)
    return true
  }

  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

  getStyleModal(opt) {
    if(opt === 'isOpenAltaProductos' || opt === 'isOpenConfirmInfoProducto') {
      return { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '50%',height: '50%',} };
    }

    return { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '80%',height: '80%',} };
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return ''+(Math.round(n * k) / k)
      .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length+1).join('0')
    }
    return s.join(dec)
  }


};

export default withRouter(ModalsVentasPage)